module.exports = __webpack_public_path__ + "static/media/fox.17758028.svg";